import { graphql } from "~/gql";

export const CREATE_MATTER_TEMPLATE = graphql(/* GraphQL */ `
  mutation createMatterTemplate($cloneTemplateId: Float, $data: MatterCreateInput!) {
    createMatterTemplate(cloneTemplateId: $cloneTemplateId, data: $data) {
      ...MatterTemplateParts
    }
  }
`);
